import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatError, MatHint} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ErrorMatcher} from '../../classes/error-matcher/error-matcher';

@Component({
    selector: 'app-password-forgot-dialog',
    imports: [
        FormsModule,
        MatError,
        MatInput,
        ReactiveFormsModule
    ],
    templateUrl: './password-forgot-dialog.component.html',
    styleUrl: './password-forgot-dialog.component.sass'
})
export class PasswordForgotDialogComponent {
    matcher = new ErrorMatcher();
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    constructor(
        public dialogRef: MatDialogRef<PasswordForgotDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.dialogRef.close(this.emailFormControl.value);
    }
}
